<template>

    <v-container fluid>
  
      <!-- 업로드 프로그레스 -->
      <comloading :isVisible="progress_dialog" :progress="progress_value" />


    <!-- 이미지 크롭 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog" @keydown.esc="cancel_crop" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">

              <vue-cropper
                  ref="cropper_land"
                  :key="option.autoCropWidth + '_' + option.autoCropHeight"
                  :src="imgSrc"
                  :aspect-ratio="option.autoCropWidth/option.autoCropHeight"
                  />

            </div>
            
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>    
      
      

      <v-row align="center" dense no-gutters>
        <v-col cols="3">
          <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
        </v-col>
        <v-spacer/>
        <v-col cols="3">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
        <v-col cols="3">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>      
      </v-row>

      <v-row justify="center" dense>

        <v-col cols="12" md="10" class="d-flex">
          <v-btn elevation="0" color="primary" width="120" @click="loadinfo_deploy">{{$t('pagesetinfo_col61')}}</v-btn>
          <v-btn  elevation="0" color="primary" class="ml-1" width="120" @click="showsite">{{$t('pagesetinfo_col62')}}</v-btn>
          <v-btn  elevation="0" color="primary" class="ml-1" width="100" @click="deploy_popup">{{$t('pagesetinfo_col63')}}</v-btn>
          <v-spacer/>
          <v-btn elevation="0" color="primary" width="100" @click="loadinfo">{{$t('pagesetinfo_col45')}}</v-btn>
          <v-btn  elevation="0" color="primary" class="ml-1" width="100" @click="showsite_temp">{{$t('pagesetinfo_col35')}}</v-btn>
          <v-btn  elevation="0" color="primary" class="ml-1" width="100" @click="save">{{$t('pagesetinfo_col36')}}</v-btn>
        </v-col>

        <v-col cols="12" md="10">

            <v-tabs
                v-model="tab"
                centered
                color="deep-purple-accent-4"
                >
                  <v-tab :value="0">{{$t('pagesetinfo_col2')}}</v-tab>  
                  <v-tab :value="1">{{$t('pagesetinfo_col3')}}</v-tab>
                  <v-spacer/>
            </v-tabs>            
            <v-tabs-items v-model="tab">
            <v-tab-item :value="0" v-if="editedItem.TITLE_INFO != null && editedItem.TITLE_INFO != undefined">
              <v-container fluid>

                <div class="input_divtitle">{{ $t('pagesetinfo_col58') }}</div>

                <div class="d-flex flex-row">
                  <div class="input_title"><span style="color:red;">*</span>{{$t('pagesetinfo_col5')}}</div>
                  <input
                    v-model="editedItem.TITLE_INFO.EVENTNAME" 
                    class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                    :placeholder="$t('pagesetinfo_col6')"
                    />
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px"
                    :color="editedItem.TITLE_INFO.EVENTNAME_FONT.COLOR" 
                    path="TITLE_INFO.EVENTNAME_FONT.COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTNAME_FONT.PCSIZE" 
                    path="TITLE_INFO.EVENTNAME_FONT.PCSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialogfontsize2 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTNAME_FONT.MBSIZE" 
                    path="TITLE_INFO.EVENTNAME_FONT.MBSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialoglineheight 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTNAME_FONT.LINEHEIGHT" 
                    path="TITLE_INFO.EVENTNAME_FONT.LINEHEIGHT" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialogfontalign                               
                    dense style="width:30px"
                    :align="editedItem.TITLE_INFO.EVENTNAME_FONT.ALIGN" 
                    path="TITLE_INFO.EVENTNAME_FONT.ALIGN" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfont class="ml-1" style="width:400px"
                    :comidx="SEARCH_COM_IDX" 
                    :font="editedItem.TITLE_INFO.EVENTNAME_FONT" 
                    @callback="callback_fontvalue"
                    />                
                </div>
    
                <div class="d-flex flex-row mt-2">
                  <div class="input_title"><span style="color:red;">*</span>{{$t('pagesetinfo_col7')}}</div>
                  <input
                    v-model="editedItem.TITLE_INFO.EVENTDATE" 
                    class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                    :placeholder="$t('pagesetinfo_col8')"
                    />
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col7')" class="ml-1" style="width:30px"
                    :color="editedItem.TITLE_INFO.EVENTDATE_FONT.COLOR" 
                    path="TITLE_INFO.EVENTDATE_FONT.COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize 
                    dense :title="$t('pagesetinfo_col7')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTDATE_FONT.PCSIZE" 
                    path="TITLE_INFO.EVENTDATE_FONT.PCSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />                
                  <dialogfontsize2
                    dense :title="$t('pagesetinfo_col7')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTDATE_FONT.MBSIZE" 
                    path="TITLE_INFO.EVENTDATE_FONT.MBSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />                
                  <dialoglineheight
                    dense :title="$t('pagesetinfo_col7')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTDATE_FONT.LINEHEIGHT" 
                    path="TITLE_INFO.EVENTDATE_FONT.LINEHEIGHT" :obj="editedItem"
                    @callback="callback_value"
                    />                
                  <dialogfontalign                               
                    dense style="width:30px"
                    :align="editedItem.TITLE_INFO.EVENTDATE_FONT.ALIGN" 
                    path="TITLE_INFO.EVENTDATE_FONT.ALIGN" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfont class="ml-1" style="width:400px"
                    :comidx="SEARCH_COM_IDX" 
                    :font="editedItem.TITLE_INFO.EVENTDATE_FONT" 
                    @callback="callback_fontvalue"
                    />                
                </div>
    
                <div class="d-flex flex-row mt-2">
                  <div class="input_title"><span style="color:red;">*</span>{{$t('pagesetinfo_col9')}}</div>
                  <input
                    v-model="editedItem.TITLE_INFO.EVENTPLACE" 
                    class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                    :placeholder="$t('pagesetinfo_col10')"
                    />
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :color="editedItem.TITLE_INFO.EVENTPLACE_FONT.COLOR" 
                    path="TITLE_INFO.EVENTPLACE_FONT.COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTPLACE_FONT.PCSIZE" 
                    path="TITLE_INFO.EVENTPLACE_FONT.PCSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize2 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTPLACE_FONT.MBSIZE" 
                    path="TITLE_INFO.EVENTPLACE_FONT.MBSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialoglineheight 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.EVENTPLACE_FONT.LINEHEIGHT" 
                    path="TITLE_INFO.EVENTPLACE_FONT.LINEHEIGHT" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontalign                               
                    dense style="width:30px"
                    :align="editedItem.TITLE_INFO.EVENTPLACE_FONT.ALIGN" 
                    path="TITLE_INFO.EVENTPLACE_FONT.ALIGN" :obj="editedItem"
                    @callback="callback_value"
                    />

                  <dialogfont class="ml-1" style="width:400px"
                    :comidx="SEARCH_COM_IDX" 
                    :font="editedItem.TITLE_INFO.EVENTPLACE_FONT" 
                    @callback="callback_fontvalue"
                    />                
                </div>

                <div class="d-flex flex-row mt-2 align-center">
                  <label class="input_title">{{$t('pagesetinfo_col11')}}</label>
                  <v-select 
                    v-model="editedItem.TITLE_INFO.PCBG_TYPE" :items="URLTYPELIST" :placeholder="$t('pagesetinfo_col11')" 
                    item-text="name" item-value="value" outlined dense 
                    hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
                    bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
                    />

                  <dialogcolor v-if="editedItem.TITLE_INFO.PCBG_TYPE == 1"
                    dense :title="$t('pagesetinfo_col12')" class="ml-3" style="width:30px;"
                    :color="editedItem.TITLE_INFO.PCBG_COLOR" 
                    path="TITLE_INFO.PCBG_COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />

                  <a v-if="editedItem.TITLE_INFO.PCBG_TYPE == 3" class="ml-10"
                    target="_blank" href="https://pie-bayberry-02f.notion.site/FAIRPASS-PC-1b3454ba2ae980fc84a8f0f9acf58e15">
                    {{ $t('pagesetinfo_col57') }}
                  </a>

                </div>            
                <!-- 
                <div style="height:140px" v-if="editedItem.TITLE_INFO.PCBG_TYPE == 1">
                  <dialogbgcolor 
                    dense :title="$t('pagesetinfo_col12')" ref="bgcolor" 
                    :color="editedItem.TITLE_INFO.PCBG_COLOR"  :obj="editedItem"
                    path="TITLE_INFO.PCBG_COLOR"
                    @callback="callback_value"
                    />
                </div>
                -->
                <div class="mt-1" v-if="editedItem.TITLE_INFO.PCBG_TYPE == 2">
                  <div class="input_title w-100">{{$t('pagesetinfo_col13')}}</div>
                </div>
                <div class="mt-1" style="height:140px" v-if="editedItem.TITLE_INFO.PCBG_TYPE == 2">
                  <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                    @click="fileSelect('TITLE_INFO.PCBG_URL', 1920, 912)"
                    >
                      <img 
                        height="120"
                        :src="getNestedProperty(previewImg, 'TITLE_INFO.PCBG_URL')"
                        class="image" style="cursor:pointer"
                        />
                        <!-- @click="showImage(previewImg, 'TITLE_INFO.PCBG_URL')" -->
                      <v-icon 
                        style="position:absolute; bottom:8px; right:8px; cursor:pointer;"
                        >
                        mdi-pencil
                      </v-icon>
                  </div>
                </div>        
                <div v-if="editedItem.TITLE_INFO.PCBG_TYPE > 2">
                  <div class="d-flex flex-row mt-2">
                    <div class="input_title">{{$t('pagesetinfo_col14')}}</div>
                    <input
                      v-model="editedItem.TITLE_INFO.PCBG_URL" 
                      class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                      :placeholder="$t('pagesetinfo_col15')"
                      />
                  </div>
                </div>
    
                <div class="d-flex flex-row mt-2 align-center">
                  <label class="input_title">{{$t('pagesetinfo_col16')}}</label>
                  <v-select 
                    v-model="editedItem.TITLE_INFO.MBBG_TYPE" :items="URLTYPELIST" :placeholder="$t('pagesetinfo_col16')" 
                    item-text="name" item-value="value" outlined dense 
                    hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
                    bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
                    />
                  <dialogcolor v-if="editedItem.TITLE_INFO.MBBG_TYPE == 1"
                    dense :title="$t('pagesetinfo_col17')" class="ml-3" style="width:30px;"
                    :color="editedItem.TITLE_INFO.MBBG_COLOR" 
                    path="TITLE_INFO.MBBG_COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <a v-if="editedItem.TITLE_INFO.MBBG_TYPE == 3" class="ml-10"
                    target="_blank" href="https://pie-bayberry-02f.notion.site/FAIRPASS-PC-1b3454ba2ae980fc84a8f0f9acf58e15">
                    {{ $t('pagesetinfo_col57') }}
                  </a>

                </div>            
                <!-- 
                <div style="height:140px" v-if="editedItem.TITLE_INFO.MBBG_TYPE == 1">
                  <dialogbgcolor 
                    dense :title="$t('pagesetinfo_col17')" ref="bgcolor" 
                    :color="editedItem.TITLE_INFO.MBBG_COLOR" 
                    path="TITLE_INFO.MBBG_COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                </div>
                -->
    
                <div class="mt-1" v-if="editedItem.TITLE_INFO.MBBG_TYPE == 2">
                  <div class="input_title w-100">{{$t('pagesetinfo_col18')}}</div>
                </div>
                <div class="mt-1" style="height:140px" v-if="editedItem.TITLE_INFO.MBBG_TYPE == 2">
                  <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                      @click="fileSelect('TITLE_INFO.MBBG_URL', 460, 912)"
                      >
                      <img 
                        height="120"
                        :src="getNestedProperty(previewImg, 'TITLE_INFO.MBBG_URL')"
                        class="image" style="cursor:pointer"
                        />
                        <!-- @click="showImage(previewImg, 'TITLE_INFO.MBBG_URL')" -->
                      <v-icon 
                        style="position:absolute; bottom:8px; right:8px;"
                        >
                        mdi-pencil
                      </v-icon>
                  </div>
                </div>        
                <div v-if="editedItem.TITLE_INFO.MBBG_TYPE > 2">
                  <div class="d-flex flex-row mt-2">
                    <div class="input_title">{{$t('pagesetinfo_col14')}}</div>
                    <input
                      v-model="editedItem.TITLE_INFO.MBBG_URL" 
                      class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                      :placeholder="$t('pagesetinfo_col15')"
                      />
                  </div>
                </div>                        


                <!-- 메뉴바 부분 -->
                <div class="input_divtitle mt-5">{{ $t('pagesetinfo_col59') }}</div>
                <div class="d-flex flex-row align-center">
                  <div class="input_title">{{$t('pagesetinfo_col52')}}</div>
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :color="editedItem.TITLE_INFO.MENUTITLE_FONT.COLOR" 
                    path="TITLE_INFO.MENUTITLE_FONT.COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :size="editedItem.TITLE_INFO.MENUTITLE_FONT.PCSIZE" 
                    path="TITLE_INFO.MENUTITLE_FONT.PCSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialogfontsize2 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :size="editedItem.TITLE_INFO.MENUTITLE_FONT.MBSIZE" 
                    path="TITLE_INFO.MENUTITLE_FONT.MBSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialoglineheight 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :size="editedItem.TITLE_INFO.MENUTITLE_FONT.LINEHEIGHT" 
                    path="TITLE_INFO.MENUTITLE_FONT.LINEHEIGHT" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialogfont class="ml-1" style="width:400px"
                    :comidx="SEARCH_COM_IDX" 
                    :font="editedItem.TITLE_INFO.MENUTITLE_FONT" 
                    @callback="callback_fontvalue"
                    />     
                </div>                

                <div class="d-flex flex-row mt-2">
                  <div class="input_title">{{$t('pagesetinfo_col47')}}</div>
                  <input
                    v-model="editedItem.TITLE_INFO.EVENTSUBNAME" 
                    class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                    :placeholder="$t('pagesetinfo_col48')" 
                    />
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :color="editedItem.TITLE_INFO.EVENTSUBNAME_FONT.COLOR" 
                    path="TITLE_INFO.EVENTSUBNAME_FONT.COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :size="editedItem.TITLE_INFO.EVENTSUBNAME_FONT.PCSIZE" 
                    path="TITLE_INFO.EVENTSUBNAME_FONT.PCSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialogfontsize2 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :size="editedItem.TITLE_INFO.EVENTSUBNAME_FONT.MBSIZE" 
                    path="TITLE_INFO.EVENTSUBNAME_FONT.MBSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialoglineheight 
                    dense :title="$t('pagesetinfo_col5')" class="ml-1" style="width:30px;"
                    :size="editedItem.TITLE_INFO.EVENTSUBNAME_FONT.LINEHEIGHT" 
                    path="TITLE_INFO.EVENTSUBNAME_FONT.LINEHEIGHT" :obj="editedItem"
                    @callback="callback_value"
                    />     
                  <dialogfont class="ml-1" style="width:400px"
                    :comidx="SEARCH_COM_IDX" 
                    :font="editedItem.TITLE_INFO.EVENTSUBNAME_FONT" 
                    @callback="callback_fontvalue"
                    />        
                </div>                       

                <v-row justify="center" align="center" class="mt-2" dense>
                  <v-col cols="12" md="12">
                    <div class="input_title w-100">{{$t('pagesetinfo_col4')}}</div>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" style="height:140px" no-gutters>
                  <v-col cols="12" md="12" align="center" align-self="center" style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                    @click="fileSelect('PAGELOGO', 300, 300)"
                    >
                    <img 
                      height="120"
                      :src="getNestedProperty(previewImg, 'PAGELOGO')"
                      class="image" style="cursor:pointer"
                      />
                      <!-- @click="showImage(previewImg, 'PAGELOGO')" -->
                    <v-icon 
                      style="position:absolute; bottom:8px; right:8px; cursor:pointer;"
                      >
                      mdi-pencil
                    </v-icon>
                  </v-col>
              </v-row>                


                <div class="d-flex flex-row mt-2">
                  <div class="input_title">{{$t('pagesetinfo_col49')}}</div>
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :color="editedItem.TITLE_INFO.MENUNAME_FONT.COLOR" 
                    path="TITLE_INFO.MENUNAME_FONT.COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.MENUNAME_FONT.PCSIZE" 
                    path="TITLE_INFO.MENUNAME_FONT.PCSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfontsize2 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :size="editedItem.TITLE_INFO.MENUNAME_FONT.MBSIZE" 
                    path="TITLE_INFO.MENUNAME_FONT.MBSIZE" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <dialogfont class="ml-1" style="width:400px"
                    :comidx="SEARCH_COM_IDX" 
                    :font="editedItem.TITLE_INFO.MENUNAME_FONT" 
                    @callback="callback_fontvalue"
                    />                
                </div>

                <div class="d-flex flex-row align-center mt-0">
                  <div class="input_title">{{$t('pagesetinfo_col50')}}</div>
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :color="editedItem.TITLE_INFO.MENUBAR_COLOR" 
                    path="TITLE_INFO.MENUBAR_COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />
                  <label class="input_title ml-5">{{$t('pagesetinfo_col51')}}</label>
                  <v-checkbox dense v-model="editedItem.TITLE_INFO.MENUBAR_EFFECT" class="ml-5"/>

                  <label class="input_title_nowidth ml-5" style="width:200px">{{$t('pagesetinfo_col54')}}</label>
                  <dialogcolor 
                    dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                    :color="editedItem.TITLE_INFO.SIDEBG_COLOR" 
                    path="TITLE_INFO.SIDEBG_COLOR" :obj="editedItem"
                    @callback="callback_value"
                    />

                </div>                
                
                <div class="d-flex flex-row mt-0">
                  <div class="input_title">{{$t('pagesetinfo_col53')}}</div>
                  <input
                    v-model="editedItem.TITLE_INFO.REGBTN_NAME" 
                    class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                    :placeholder="$t('pagesetinfo_col56')" 
                    />
                </div>

              

              </v-container>
            </v-tab-item>
            <v-tab-item :value="1" v-if="editedItem.BOTTOM_INFO != null && editedItem.BOTTOM_INFO != undefined">
                <v-container fluid>

                  <div class="d-flex flex-row mt-2">
                    <div class="input_title"><span style="color:red;">*</span>{{$t('pagesetinfo_col19')}}</div>
                    <v-spacer/>
                    <dialogcolor 
                      dense :title="$t('pagesetinfo_col19')" class="ml-1" style="width:30px"
                      :color="editedItem.BOTTOM_INFO.INFO_FONT.COLOR" 
                      path="BOTTOM_INFO.INFO_FONT.COLOR" :obj="editedItem"
                      @callback="callback_value"
                      />
                    <dialogfontsize 
                      dense :title="$t('pagesetinfo_col19')" class="ml-1" style="width:30px"
                      :size="editedItem.BOTTOM_INFO.INFO_FONT.PCSIZE" 
                      path="BOTTOM_INFO.INFO_FONT.PCSIZE" :obj="editedItem"
                      @callback="callback_value"
                      />                
                    <dialogfontsize2
                      dense :title="$t('pagesetinfo_col19')" class="ml-1" style="width:30px"
                      :size="editedItem.BOTTOM_INFO.INFO_FONT.MBSIZE" 
                      path="BOTTOM_INFO.INFO_FONT.MBSIZE" :obj="editedItem"
                      @callback="callback_value"
                      />                
                    <dialoglineheight
                      dense :title="$t('pagesetinfo_col19')" class="ml-1" style="width:30px"
                      :size="editedItem.BOTTOM_INFO.INFO_FONT.LINEHEIGHT" 
                      path="BOTTOM_INFO.INFO_FONT.LINEHEIGHT" :obj="editedItem"
                      @callback="callback_value"
                      />                
                    <dialogfontalign                               
                      dense style="width:30px"
                      :align="editedItem.BOTTOM_INFO.INFO_FONT.ALIGN" 
                      path="BOTTOM_INFO.INFO_FONT.ALIGN" :obj="editedItem"
                      @callback="callback_value"
                      />
  
                    <dialogfont class="ml-1" style="width:400px"
                      :comidx="SEARCH_COM_IDX" 
                      :font="editedItem.BOTTOM_INFO.INFO_FONT" 
                      @callback="callback_fontvalue"
                      />                
                  </div>
                  <div class="d-flex flex-row mt-1">
                    <v-textarea
                      v-model="editedItem.BOTTOM_INFO.INFO" 
                      outlined
                      style="white-space:pre-line;width:100%"
                      rows="3" bg-color="#ffffff" 
                      type="text" color="#FF6000"
                      :placeholder="$t('pagesetinfo_col21')"
                      dense single-line hide-details
                      />
                  </div>
      
                  <div class="d-flex flex-row mt-2">
                    <div class="input_title"><span style="color:red;">*</span>{{$t('pagesetinfo_col22')}}</div>
                    <v-spacer/>
                    <dialogcolor 
                      dense :title="$t('pagesetinfo_col22')" class="ml-1" style="width:30px"
                      :color="editedItem.BOTTOM_INFO.ADDR_FONT.COLOR" 
                      path="BOTTOM_INFO.ADDR_FONT.COLOR" :obj="editedItem"
                      @callback="callback_value"
                      />
                    <dialogfontsize 
                      dense :title="$t('pagesetinfo_col22')" class="ml-1" style="width:30px"
                      :size="editedItem.BOTTOM_INFO.ADDR_FONT.PCSIZE" 
                      path="BOTTOM_INFO.ADDR_FONT.PCSIZE" :obj="editedItem"
                      @callback="callback_value"
                      />             
                    <dialogfontsize2 
                      dense :title="$t('pagesetinfo_col22')" class="ml-1" style="width:30px"
                      :size="editedItem.BOTTOM_INFO.ADDR_FONT.MBSIZE" 
                      path="BOTTOM_INFO.ADDR_FONT.MBSIZE" :obj="editedItem"
                      @callback="callback_value"
                      />             
                    <dialoglineheight 
                      dense :title="$t('pagesetinfo_col22')" class="ml-1" style="width:30px"
                      :size="editedItem.BOTTOM_INFO.ADDR_FONT.LINEHEIGHT" 
                      path="BOTTOM_INFO.ADDR_FONT.LINEHEIGHT" :obj="editedItem"
                      @callback="callback_value"
                      />             
                    <dialogfontalign                               
                      dense style="width:30px"
                      :align="editedItem.BOTTOM_INFO.ADDR_FONT.ALIGN" 
                      path="BOTTOM_INFO.ADDR_FONT.ALIGN" :obj="editedItem"
                      @callback="callback_value"
                      />
  
                    <dialogfont class="ml-1" style="width:400px"
                      :comidx="SEARCH_COM_IDX" 
                      :font="editedItem.BOTTOM_INFO.ADDR_FONT" 
                      @callback="callback_fontvalue"
                      />                
                  </div>
                  <div class="d-flex flex-row mt-1">
                    <v-textarea
                      v-model="editedItem.BOTTOM_INFO.ADDR" 
                      outlined
                      style="white-space:pre-line;width:100%"
                      rows="3" bg-color="#ffffff" 
                      type="text" color="#FF6000"
                      :placeholder="$t('pagesetinfo_col23')"
                      dense single-line hide-details
                      />
                  </div>
      
                  <div class="d-flex flex-row mt-2">
                    <label class="input_title">{{$t('pagesetinfo_col24')}}</label>
                    <dialogcolor 
                      dense :title="$t('pagesetinfo_col12')" class="ml-3" style="width:30px;"
                      :color="editedItem.BOTTOM_INFO.BG_COLOR" 
                      path="BOTTOM_INFO.BG_COLOR" :obj="editedItem"
                      @callback="callback_value"
                      />
                  </div>            
                  <!-- 
                  <div style="height:140px">
                    <dialogbgcolor 
                      dense :title="$t('pagesetinfo_col12')" ref="bgcolor" 
                      :color="editedItem.BOTTOM_INFO.BG_COLOR" 
                      path="BOTTOM_INFO.BG_COLOR" :obj="editedItem"
                      @callback="callback_value"
                      />
                  </div>                  
                  -->

                    <div class="d-flex flex-row mt-2">
                        <div class="input_title">{{$t('pagesetinfo_col25')}}</div>
                        <input
                          v-model="editedItem.BOTTOM_INFO.LINK_YOUTUBE" 
                          class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                          :placeholder="$t('pagesetinfo_col26')"
                          />
                      </div>
            
                      <div class="d-flex flex-row mt-2">
                        <div class="input_title">{{$t('pagesetinfo_col27')}}</div>
                        <input
                          v-model="editedItem.BOTTOM_INFO.LINK_INSTA" 
                          class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                          :placeholder="$t('pagesetinfo_col28')"
                          />
                      </div>

                      <div class="d-flex flex-row mt-2">
                        <div class="input_title">{{$t('pagesetinfo_col29')}}</div>
                        <input
                          v-model="editedItem.BOTTOM_INFO.LINK_NAVER" 
                          class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                          :placeholder="$t('pagesetinfo_col30')"
                          />
                      </div>

                      <div class="d-flex flex-row mt-2">
                        <div class="input_title">{{$t('pagesetinfo_col31')}}</div>
                        <input
                          v-model="editedItem.BOTTOM_INFO.LINK_FACEBOOK" 
                          class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                          :placeholder="$t('pagesetinfo_col32')"
                          />
                      </div>

                      <div class="d-flex flex-row mt-2">
                        <div class="input_title">{{$t('pagesetinfo_col33')}}</div>
                        <input
                          v-model="editedItem.BOTTOM_INFO.LINK_LINKEDIN" 
                          class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                          :placeholder="$t('pagesetinfo_col34')"
                          />
                      </div>

                </v-container>
            </v-tab-item>

          </v-tabs-items>

        </v-col>      
    </v-row>
  
    </v-container>
  </template>
  
  <script>
import VueCropper from 'vue-cropperjs'; //이미지 크롭
import 'cropperjs/dist/cropper.css';
//import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리
import cmvalidation from '../assets/js/cmvalidation.js'

  export default {
      components:{
        VueCropper
      },
  
      data: () => ({
        
        tab: null,

        progress_dialog : false,    //로딩 표시
        progress_value:0,

        //이미지 크롭
        crop_dialog: false,
        imgSrc:'',
        s3: null,   //aws

        uploadFile : [],
        photo_index: 0,
        previewImg:[],      //이미지 미리보기

        //신규 크롭 파라메터
        option: {
            img: "",
            outputSize: 1,
            outputType: "jpg",
            canMove: true,
            fixed: true,                  //크롭박스 비율 고정
            fixedNumber: [1920, 340],    //크롭박스 비율
            fixedBox: false,      //true면 크롭박스 크기 조절 안됨
            original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
            canMoveBox: true,
            autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
            autoCropWidth:100,    //크롭박스의 가로 크기 fixed가 true면 비율대로
            autoCropHeight:100,   //크롭박스의 세로 크기 
            centerBox: true,
            high: false,
            cropData: {},
            enlarge: 1,
            mode: 'contain',
            maxImgSize: 5000,
            limitMinSize: [1000, 300]
        },

        //필수 페이징 파라메터
        totalcnt : 0,       //전체 아이템 개수
        page : 0,
        maxpage : 0,        //전체 페이지 개수
        startpage : 1,      //시작 인덱스
        bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
        subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
        loading : false,    //로딩 표시

        //CRUD 관련
        dialogTitle: '추가하기',   //다이얼로그 제목
        editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
        defaultItem: {
            PAGELOGO: null
          , TITLE_INFO: {
              PCBG_TYPE:0
            , PCBG_URL:""
            , PCBG_COLOR:""
            , MBBG_TYPE:0
            , MBBG_URL:""
            , MBBG_COLOR:""
            , MENUBAR_COLOR: "#00000040"
            , MENUBAR_EFFECT: 1
            , SIDEBG_COLOR: "#222222FF"
            , REGBTN_NAME:"등록확인"
            , EVENTNAME:""
            , EVENTNAME_FONT:{
                NAME:"나눔고딕 ExtraBold"
              , CODE:"나눔고딕 ExtraBold"
              , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothicExtraBold.ttf"
              , PCSIZE: 108
              , MBSIZE: 50
              , LINEHEIGHT: 120
              , COLOR: "#FFFFFFFF"
              , ALIGN: "left"
            }
            , EVENTSUBNAME:""
            , EVENTSUBNAME_FONT:{
                NAME:"나눔고딕"
              , CODE:"나눔고딕"
              , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
              , PCSIZE: 16
              , MBSIZE: 14
              , LINEHEIGHT: 100
              , COLOR: "#80858bFF"
              , ALIGN: "left"
            }
            , EVENTDATE:""
            , EVENTDATE_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 32
                , MBSIZE: 20
                , LINEHEIGHT: 110
                , COLOR: "#D7D7D7FF"
                , ALIGN: "left"
            }
            , EVENTPLACE:""
            , EVENTPLACE_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 32
                , MBSIZE: 20
                , LINEHEIGHT: 110
                , COLOR: "#D7D7D7FF"
                , ALIGN: "left"
            }
            , MENUTITLE_FONT:{
                NAME:"나눔고딕"
              , CODE:"나눔고딕"
              , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
              , PCSIZE: 30
              , MBSIZE: 20
              , LINEHEIGHT: 120
              , COLOR: "#FFFFFFFF"
              , ALIGN: "left"
              }
            , MENUNAME_FONT:{
                NAME:"나눔고딕"
              , CODE:"나눔고딕"
              , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
              , PCSIZE: 18
              , MBSIZE: 18
              , LINEHEIGHT: 120
              , COLOR: "#84858bff"
              , ALIGN: "left"
            }

          }
          
          , BOTTOM_INFO:{
              LINK_YOUTUBE:""
            , LINK_INSTA:""
            , LINK_NAVER:""
            , LINK_FACEBOOK:""
            , LINK_LINKEDIN:""
            , BG_COLOR:""
            , INFO:""
            , INFO_FONT:{
                  NAME:"Noto Sans Bold"
                , CODE:"Noto Sans Bold"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NotoSans-Bold.ttf"
                , PCSIZE: 18
                , MBSIZE: 14
                , LINEHEIGHT: 120
                , COLOR: "#7F7F7FFF"
                , ALIGN: "left"
              }
            , ADDR:""
            , ADDR_FONT:{
                  NAME:"Noto Sans"
                , CODE:"Noto Sans"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NotoSans-Regular.ttf"
                , PCSIZE: 14
                , MBSIZE: 14
                , LINEHEIGHT: 120
                , COLOR: "#7F7F7FFF"
                , ALIGN: "left"
              }

          }          
        },
        editedItem: {},

        BGTYPELIST: [
            {name:'BASIC',      value:0}
          , {name:'COLOR',       value:1}
          , {name:'IMAGE',     value:2}
        ],

        URLTYPELIST: [
            {name:'BASIC',       value:0}
          , {name:'COLOR',       value:1}
          , {name:'IMAGE',     value:2}
          , {name:'YOUTUBE',  value:3}
        ],

        VIDEOTYPELIST:[
            {name:'YOUTUBE',  value:0}
        ],

        
        grade : 0,
        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',

        select_lan : 0


      }),
  
      beforeMount(){
        //로드전에 객체화 (경고 메시지 안나오게)
        this.editedItem = Object.assign({}, this.defaultItem);
      },
  
      mounted(){

        if(this.$session.get("GRADE") < 10){
          this.$alert(this.$t("common_nograde"));
          this.$router.push("Login");
          return;
        }
  
        this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
        this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
        this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
        this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
        this.grade = this.$session.get("GRADE");
  
        if(this.$session.exists("ADMIN_IDX")){
          this.initpage();
        }else{
          //키값 없으면 로그인으로
          this.$router.push("Login");
        }
      },
  
      create(){
  
      },


      beforeDestroy(){
        //아이폰의 경우 찌거기 제거
        let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
        if(indexcnt > -1){
            let elements = document.getElementsByName("imageinputcamera");
            for(var i=0, len=elements.length ; i != len; ++i){
                elements[0].parentNode.removeChild(elements[0]);
            }
        }
      },      
  
      methods: {
  
        showsite(){
          window.open("https://fairpass.co.kr?eventcode="+this.SEARCH_EVENT_IDX, "_blank");
        },

        showsite_temp(){
          window.open("https://fairpass.co.kr/IntroTest?eventcode="+this.SEARCH_EVENT_IDX, "_blank");
          //window.open("http://192.168.0.39:8082/IntroTest?eventcode="+this.SEARCH_EVENT_IDX, "_blank");
        },

        callback_fontvalue(value, obj){
          let target      = obj;
          target.NAME     = value.NAME;
          target.CODE     = value.CODE;
          target.FONTURL  = value.FONTURL;
          this.$forceUpdate();
        },

        callback_value(value, path, obj){

          const keys = path.split('.');
          let target = obj;

          for (let i = 0; i < keys.length - 1; i++) {
            // 배열 인덱스 처리
            const key = keys[i].match(/^(\w+)\[(\d+)\]$/);
            if (key) {
              const arrayKey = key[1]; // 배열 이름
              const index = parseInt(key[2], 10); // 배열 인덱스

              // 배열이 없으면 생성
              if (!target[arrayKey]) {
                target[arrayKey] = [];
              }

              // 인덱스 위치에 객체가 없으면 생성
              if (!target[arrayKey][index]) {
                target[arrayKey][index] = {};
              }

              target = target[arrayKey][index];
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                target[keys[i]] = {};
              }
              target = target[keys[i]];
            }
          }        

          // 마지막 키에 값 설정
          const lastKey = keys[keys.length - 1];
          const lastKeyMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);
          if (lastKeyMatch) {
            const arrayKey = lastKeyMatch[1];
            const index = parseInt(lastKeyMatch[2], 10);

            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            target[arrayKey][index] = value;
          } else {
            target[lastKey] = value;
          }        
        
          this.$forceUpdate();

        },        

        cancel_crop(){
            this.crop_dialog = false;
        },

        cropimg(){

          this.crop_dialog = false;
          this.$refs.cropper_land.getCroppedCanvas().toBlob((blob) => {
            this.setNestedProperty(this.uploadFile, this.photo_key, blob);
          });
          this.setNestedProperty(this.previewImg, this.photo_key, this.$refs.cropper_land.getCroppedCanvas().toDataURL("image/jpeg"));

        },              

        showImage(obj, path){

          const value = this.getNestedProperty(obj, path);

          if(!value){
              return;
          }
            
          this.$viewerApi({
              options: {
                  zIndex:9999
              },          
              images: [value]
          });

        },  

        fileSelect(key, width, height){

            const changefunction = this.selectfile;
            var input = document.createElement("input");
            input.style = "display:none";
            input.name = "imageinputcamera";
            input.type = "file";
            input.accept = ".jpg,.jpeg,.png"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

            /* 크롭사이즈 변경 */
            if(width != null && height != null){
              this.option.autoCropWidth  = width;
              this.option.autoCropHeight = height;
              this.option.aspectRatio = width/height;
              this.option.fixed = true;
            }else{
              this.option.autoCropWidth  = NaN;
              this.option.autoCropHeight = NaN;
              this.option.aspectRatio = NaN;
              this.option.fixed = false;
            }
            this.$forceUpdate();

            let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
            if(indexcnt > -1){
                //아이폰, 아이패드, 맥
                //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
                document.body.appendChild(input);
                input.onchange = function (event) {
                    document.body.removeChild(input);
                    changefunction(event.target.files[0], key);
                };
            }else{
                input.onchange = function (event) {
                    changefunction(event.target.files[0], key);
                };
            }
            input.click();
        },           

        //아이콘에서 파일 변경시
        selectfile(file, key){

            if(file.size/1024/1024 > 10){
                this.$alert(this.$t('eul_msg101'));
                this.setNestedProperty(this.uploadFile, key, null);
                //this.uploadFile[key] = null;
                return;
            }

            const reader = new FileReader();
            reader.onload = (event)=>{
                this.photo_key    = key;
                this.crop_dialog  = true;
                this.imgSrc       = event.target.result;  //이게 blob데이터
                this.$refs.cropper_land.replace(event.target.result);
            }
            reader.readAsDataURL(file);  //비동기로 파일을 읽어서

        },      

        /**
         * 이미지 업로드
         * @param {number} korname   - 업로드 구분값 (오류시 보여줌)
         * @param {number} imgparam  - 저장할 파일명 이름 
         * @param {number} path      - 이미지 URL을 저장할 객체의 path 
         * @returns {number} 두 숫자의 합
         */        
        async checkimgupload(korname, imgparam, path){
            
            const s3obj     = this.$s3;
            const folder    = this.SEARCH_COM_IDX.toString();         //중간폴더명
            var albumPhotosKey = encodeURIComponent(folder) + "/";    //중간경로명  /게 붙어야 폴더됨.
            // s3에 폴더 생성
            // eslint-disable-next-line no-unused-vars
            await s3obj.putObject({Key: albumPhotosKey}, async (err2, data2) => {
                if(err2) {
                    //앨범생성 오류
                    this.$alert(this.$t('eventinfo_msg16'));
                    return false;
                }
            });   

            //파일이 지정된 경우
            const filevalue = this.getNestedProperty(this.uploadFile, path);
            if(filevalue){
                this.progress_dialog = true;            
                let imgpath;
                let curdate = Date.now().toString();    //무조건 신규 파일명으로 그래야 디자인 갱신됨.
                imgpath  = `${imgparam}_${curdate}.jpg`;
                
                var photoKey = albumPhotosKey + imgpath;                 //최종 경로
                const stored = await s3obj.upload({
                                                        Bucket: "blueorigin-mice-image",
                                                        Key: photoKey,
                                                        Body: filevalue,
                                                        ACL: "public-read"
                                                    }).promise();

                if(stored == null || stored.Location == null){
                    this.progress_dialog = false;
                    this.$fire({ 
                        html:`${this.$t('common_process_fail')} <br> ${korname}`
                    });
                    return false;
                }
                //this.uploadFile[fileindex]  = null;
                this.progress_dialog = false;
                this.setNestedProperty(this.uploadFile, path, null);
                this.setNestedProperty(this.editedItem, path, stored.Location);          //////////////////////

                /*
                const keys = path.split('.');   // 경로를 점(.)으로 분리
                let target = this.editedItem;   // 현재 객체를 탐색
                for (let i = 0; i < keys.length - 1; i++) {
                  if (!target[keys[i]]) {
                    target[keys[i]] = {}; // 키가 없으면 빈 객체 생성
                  }
                  target = target[keys[i]]; // 다음 단계로 이동
                }
                target[keys[keys.length - 1]] = stored.Location;

                //this.editedItem[imgparam]   = stored.Location;
                */
              
                return true;

            }else{
              //파일이 없어도 패스
              this.progress_dialog = false;
              return true;
            }

        },        

        //obj의 path에 값을 저장한다. path는 프로퍼티, 배열인덱스 가능
        setNestedProperty(obj, path, value) {

          const keys = path.split('.'); // 경로를 점(.)으로 분리
          let target = obj;

          for (let i = 0; i < keys.length - 1; i++) {

            // 배열 인덱스 처리
            const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
            if (arrayMatch) {
              const arrayKey = arrayMatch[1]; // 배열 이름
              const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

              // 배열이 없으면 생성
              if (!target[arrayKey]) {
                target[arrayKey] = [];
              }

              // 배열의 인덱스에 객체가 없으면 생성
              if (!target[arrayKey][index]) {
                target[arrayKey][index] = {};
              }

              target = target[arrayKey][index]; // 다음 단계로 이동
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                target[keys[i]] = {}; // 키가 없으면 객체 생성
              }
              target = target[keys[i]]; // 다음 단계로 이동
            }
          }

          // 마지막 키에 값 설정
          const lastKey = keys[keys.length - 1];
          const lastArrayMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);

          if (lastArrayMatch) {
            const arrayKey = lastArrayMatch[1];
            const index = parseInt(lastArrayMatch[2], 10);

            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            target[arrayKey][index] = value;
          } else {
            target[lastKey] = value;
          }
        },

        //obj의 특정 path에서 값을 가져온다.
        getNestedProperty(obj, path) {
          
          const keys = path.split('.'); // 경로를 점(.)으로 분리
          let target = obj;

          for (let i = 0; i < keys.length; i++) {
            // 배열 인덱스 처리
            const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
            if (arrayMatch) {
              const arrayKey = arrayMatch[1]; // 배열 이름
              const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

              if (!target[arrayKey] || !Array.isArray(target[arrayKey]) || !target[arrayKey][index]) {
                return undefined; // 배열 또는 인덱스가 유효하지 않으면 undefined 반환
              }
              target = target[arrayKey][index];
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                return undefined; // 키가 없으면 undefined 반환
              }
              target = target[keys[i]];
            }
          }

          return target; // 최종 값을 반환
        },


        loadpage(){

            this.editedItem = {};
            
            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == null){
              this.$alert(this.$t("common_select_event"));
              return;
            }

            this.progress_dialog = true;

            this.$http.post(this.$host+'/api/getPageInfo',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.SEARCH_COM_IDX
                , EVENT_IDX: this.SEARCH_EVENT_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.progress_dialog = false;
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                if(result.data.resultData.length == 0){

                  //최초
                  this.editedItem = Object.assign({}, this.defaultItem);
                  this.editedItem.TITLE_INFO.EVENTNAME = this.SEARCH_EVENT_NAME;

                }else{

                    //로드한 경우
                    this.editedItem = Object.assign({}, this.defaultItem);
                    
                    this.editedItem.PAGELOGO = result.data.resultData[0].PAGELOGO_TEMP;
                    this.setNestedProperty(this.previewImg, "PAGELOGO", result.data.resultData[0].PAGELOGO_TEMP);
                    
                    if(result.data.resultData[0].TITLE_INFO_TEMP != null && result.data.resultData[0].TITLE_INFO_TEMP != undefined){
                      
                      //this.editedItem.TITLE_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].TITLE_INFO));
                      const temp = JSON.parse(JSON.stringify(result.data.resultData[0].TITLE_INFO_TEMP));
                      this.editedItem.TITLE_INFO = { ...this.defaultItem.TITLE_INFO, ...temp }; //양식이 변경된 경우대비

                      this.setNestedProperty(this.previewImg, "TITLE_INFO.PCBG_URL", this.editedItem.TITLE_INFO.PCBG_URL);
                      this.setNestedProperty(this.previewImg, "TITLE_INFO.MBBG_URL", this.editedItem.TITLE_INFO.MBBG_URL);
                    }

                    if(result.data.resultData[0].BOTTOM_INFO_TEMP != null && result.data.resultData[0].BOTTOM_INFO_TEMP != undefined){
                      this.editedItem.BOTTOM_INFO     = JSON.parse(JSON.stringify(result.data.resultData[0].BOTTOM_INFO_TEMP));  
                    }

                }
  
              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.progress_dialog = false;
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동
  
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              
              this.progress_dialog = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$alert(this.$t("common_reqer"));
              }else{
                this.$alert(error.message);
              }
            });
  
        },
  
        initpage(){

            //첫페이지 로드
            this.loadpage();

        },      
  
        //검색
        search_run(){
          this.loadpage();
        },



        //한글설정정보 가져오기
        loadinfo(){
          this.$confirm(this.$t('pagesetinfo_col60'))
          .then(() => {
            this.loadinfoeng();
          });
        },

        loadinfoeng(){

            this.editedItem = {};
            
            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == null){
              this.$alert(this.$t("common_select_event"));
              return;
            }

            this.progress_dialog = true;

            this.$http.post(this.$host+'/api/getPageInfo',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.SEARCH_COM_IDX
                , EVENT_IDX: this.SEARCH_EVENT_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.progress_dialog = false;
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                if(result.data.resultData.length == 0){
                  //최초
                  this.editedItem = Object.assign({}, this.defaultItem);

                }else{

                    //로드한 경우
                    this.editedItem = Object.assign({}, this.defaultItem);

                    this.editedItem.PAGELOGO = result.data.resultData[0].PAGELOGOENG_TEMP;
                    this.setNestedProperty(this.previewImg, "PAGELOGO", result.data.resultData[0].PAGELOGOENG_TEMP);
                    
                    if(result.data.resultData[0].TITLE_INFO_ENG_TEMP != null && result.data.resultData[0].TITLE_INFO_ENG_TEMP != undefined){
                      this.editedItem.TITLE_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].TITLE_INFO_ENG_TEMP));
                      this.setNestedProperty(this.previewImg, "TITLE_INFO.PCBG_URL", this.editedItem.TITLE_INFO.PCBG_URL);
                      this.setNestedProperty(this.previewImg, "TITLE_INFO.MBBG_URL", this.editedItem.TITLE_INFO.MBBG_URL);
                    }

                    if(result.data.resultData[0].BOTTOM_INFO_ENG_TEMP != null && result.data.resultData[0].BOTTOM_INFO_ENG_TEMP != undefined){
                      this.editedItem.BOTTOM_INFO     = JSON.parse(JSON.stringify(result.data.resultData[0].BOTTOM_INFO_ENG_TEMP));  
                    }

                }
  
              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.progress_dialog = false;
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동
  
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              
              this.progress_dialog = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$alert(this.$t("common_reqer"));
              }else{
                this.$alert(error.message);
              }
            });
  
        },        


        //한글설정정보 가져오기
        loadinfo_deploy(){
          this.$confirm(this.$t('pagesetinfo_col64'))
          .then(() => {
            this.load_deploy();
          });
        },

        load_deploy(){

            this.editedItem = {};
            
            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == null){
              this.$alert(this.$t("common_select_event"));
              return;
            }

            this.progress_dialog = true;

            this.$http.post(this.$host+'/api/getPageInfo',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.SEARCH_COM_IDX
                , EVENT_IDX: this.SEARCH_EVENT_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.progress_dialog = false;
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                if(result.data.resultData.length == 0){
                  //최초
                  this.editedItem = Object.assign({}, this.defaultItem);

                }else{

                    //로드한 경우
                    this.editedItem = Object.assign({}, this.defaultItem);

                    this.editedItem.PAGELOGO = result.data.resultData[0].PAGELOGO;
                    this.setNestedProperty(this.previewImg, "PAGELOGO", result.data.resultData[0].PAGELOGO);
                    
                    if(result.data.resultData[0].TITLE_INFO != null && result.data.resultData[0].TITLE_INFO != undefined){
                      this.editedItem.TITLE_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].TITLE_INFO));
                      this.setNestedProperty(this.previewImg, "TITLE_INFO.PCBG_URL", this.editedItem.TITLE_INFO.PCBG_URL);
                      this.setNestedProperty(this.previewImg, "TITLE_INFO.MBBG_URL", this.editedItem.TITLE_INFO.MBBG_URL);
                    }

                    if(result.data.resultData[0].BOTTOM_INFO != null && result.data.resultData[0].BOTTOM_INFO != undefined){
                      this.editedItem.BOTTOM_INFO     = JSON.parse(JSON.stringify(result.data.resultData[0].BOTTOM_INFO));  
                    }

                }
  
              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.progress_dialog = false;
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동
  
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              
              this.progress_dialog = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$alert(this.$t("common_reqer"));
              }else{
                this.$alert(error.message);
              }
            });
  
        },        


        deploy_popup(){
          this.$confirm(this.$t('pagesetinfo_col65'))
          .then(() => {
            this.deploy();
          });
        },

        //추가 저장
        async deploy () {

            this.progress_dialog = true;
            this.$http.post(this.$host+'/api/PageInfoDeploy',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.SEARCH_COM_IDX
                , EVENT_IDX: this.SEARCH_EVENT_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then(async(result)=>{

                this.progress_dialog = false;
                
                if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                        this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                        this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }
                    this.$alert(this.$t('common_process_msg')).then(()=>{
                        //this.loadpage();
                    });

                }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                }else{
                    this.$alert(this.$t('deviceadminbg_msg8'));
                }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
                this.progress_dialog = false;
                this.$alert(this.$t("common_insert_fail"));
            });

        },                      

        //추가 저장
        async save () {

          const eventName = cmvalidation.checkValReg(this.editedItem.TITLE_INFO.EVENTNAME, null, -1, -1);
          if(eventName == 1){
            this.$alert(this.$t('pagesetinfo_col40'));
            return;
          }
          const eventDate = cmvalidation.checkValReg(this.editedItem.TITLE_INFO.EVENTDATE, null, -1, -1);
          if(eventDate == 1){
            this.$alert(this.$t('pagesetinfo_col41'));
            return;
          }
          const eventPlace = cmvalidation.checkValReg(this.editedItem.TITLE_INFO.EVENTPLACE, null, -1, -1);
          if(eventPlace == 1){
            this.$alert(this.$t('pagesetinfo_col42'));
            return;
          }

          if(this.editedItem.TITLE_INFO.PCBG_TYPE == 3){
            if(!String(this.editedItem.TITLE_INFO.PCBG_URL).startsWith("https://www.youtube.com/embed/")){
              this.$alert(this.$t('pagesetinfo_col55'));
              return;
            }
          }
          if(this.editedItem.TITLE_INFO.MBBG_TYPE == 3){
            if(!String(this.editedItem.TITLE_INFO.MBBG_URL).startsWith("https://www.youtube.com/embed/")){
              this.$alert(this.$t('pagesetinfo_col55'));
              return;
            }
          }

          const info = cmvalidation.checkValReg(this.editedItem.BOTTOM_INFO.INFO, null, -1, -1);
          if(info == 1){
            this.$alert(this.$t('pagesetinfo_col43'));
            return;
          }
          const addr = cmvalidation.checkValReg(this.editedItem.BOTTOM_INFO.ADDR, null, -1, -1);
          if(addr == 1){
            this.$alert(this.$t('pagesetinfo_col44'));
            return;
          }

            const imgflag = await this.checkimgupload(this.$t('pagesetinfo_col37'), "PAGELOGO", "PAGELOGO");
            if(!imgflag){
                return;
            }

            const imgflag1 = await this.checkimgupload(this.$t('pagesetinfo_col38'), "PCBGIMG", "TITLE_INFO.PCBG_URL");
            if(!imgflag1){
                return;
            }
            const imgflag2 = await this.checkimgupload(this.$t('pagesetinfo_col39'), "MBBGIMG", "TITLE_INFO.MBBG_URL");
            if(!imgflag2){
                return;
            }

            this.progress_dialog = true;
            this.$http.post(this.$host+'/api/PageInfoUpdate',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.SEARCH_COM_IDX
                , EVENT_IDX: this.SEARCH_EVENT_IDX
                , PAGELOGO: this.editedItem.PAGELOGO
                , TITLE_INFO: JSON.stringify(this.editedItem.TITLE_INFO)
                , BOTTOM_INFO: JSON.stringify(this.editedItem.BOTTOM_INFO)
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then(async(result)=>{

                this.progress_dialog = false;
                
                if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                        this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                        this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }
                    this.$alert(this.$t('common_edit_msg')).then(()=>{
                        //this.loadpage();
                    });

                }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                }else{
                    this.$alert(this.$t('deviceadminbg_msg8'));
                }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
                this.progress_dialog = false;
                this.$alert(this.$t("common_insert_fail"));
            });

        },              
  
        //검색조건 업체 설정
        eventsearchcb(val1){
          if(val1.NAME.length > 0){
            this.SEARCH_EVENT_NAME = val1.NAME;
            this.SEARCH_EVENT_IDX  = val1.IDX;
            this.$session.set("EVENT_IDX", val1.IDX);
            this.$session.set("EVENT_NAME",val1.NAME);
          }else{
            //일단 업체 선택이 취소되면 리스트를 초기화 시켜야한다.
            
            this.SEARCH_EVENT_NAME = "";
            this.SEARCH_EVENT_IDX  = null;
            this.$session.set("EVENT_IDX", null);
            this.$session.set("EVENT_NAME", "");
          }
          this.editedItem = {};
          this.loadpage();
  
        },      
  
  
        //검색조건 업체 설정
        comsearchcb(val1){
          if(val1.NAME.length > 0){
            this.SEARCH_COM_NAME = val1.NAME;
            this.SEARCH_COM_IDX  = val1.IDX;
          }else{
            this.SEARCH_COM_NAME = '';
            this.SEARCH_COM_IDX  = null;
          }
          this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
          this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.editedItem = {};
        },
        
        // eslint-disable-next-line no-unused-vars
        comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.editedItem = {};
  
        },
  
  
        
  
      },
    
  }
  </script>
  
  <!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
  <style scoped>
  
     
  </style>